(() => {
  function mount(root) {
    root.querySelectorAll('[data-zw-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('.zw-gallery__main');
      const items = [...gallery.querySelectorAll('[data-zw-image]')];
      const thumbnails = gallery.querySelector('.zw-gallery__thumbs');
      const counter = gallery.querySelector('[data-zw-counter]');
      const dialog = gallery.querySelector('dialog');
      const large = gallery.querySelector('[data-zw-large]');
      const zoom = gallery.querySelector('[data-zw-zoom]');
      let index = 0;
      function show(next) {
        index = (next + items.length) % items.length;
        const item = items[index];
        main.src = item.dataset.zwImage;
        main.srcset = item.dataset.zwSrcset;
        main.alt = item.dataset.zwAlt;
        large.src = item.dataset.zwImage;
        large.alt = item.dataset.zwAlt;
        items.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        counter.textContent = `${index + 1} / ${items.length}`;
        const itemBounds = item.getBoundingClientRect();
        const railBounds = thumbnails.getBoundingClientRect();
        if (itemBounds.left < railBounds.left || itemBounds.right > railBounds.right) {
          const offset = thumbnails.scrollLeft + itemBounds.left - railBounds.left - (thumbnails.clientWidth - itemBounds.width) / 2;
          thumbnails.scrollTo({ left: offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }
      items.forEach((item, i) => item.addEventListener('click', () => show(i)));
      gallery.querySelector('[data-zw-prev]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-zw-next]').addEventListener('click', () => show(index + 1));
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let start;
      let swiped = false;
      zoom.addEventListener('pointerdown', event => { start = { x: event.clientX, y: event.clientY }; swiped = false; });
      zoom.addEventListener('pointerup', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          show(index + (dx < 0 ? 1 : -1));
        }
        start = undefined;
      });
      zoom.addEventListener('click', event => {
        if (swiped) { event.preventDefault(); swiped = false; return; }
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
      gallery.querySelector('[data-zw-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => zoom.focus());
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
